module.exports = __webpack_public_path__ + "static/media/Feb20-S20.a07ba0d1.png";